import { useEffect } from 'react';
import { useSmartLinkEvents } from '@atlaskit/smart-card';
import { registerSmartCardEvents } from '../pm-plugins/actions';
export var EditorSmartCardEvents = function EditorSmartCardEvents(_ref) {
  var editorView = _ref.editorView;
  var events = useSmartLinkEvents();
  useEffect(function () {
    if (!events) {
      return;
    }
    editorView.dispatch(registerSmartCardEvents(events)(editorView.state.tr));
  }, [events, editorView]);
  return null;
};